import React, { useEffect, useState } from "react";
import { Award } from "lucide-react";
import { api } from "@/lib/api";
import { HummingbirdIcon } from "@/components/Hummingbird";

export default function HummingbirdBadgeCard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/me/hummingbirds").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const pct = Math.min(100, Math.round((d.on_time * 100) / d.badge_at));
  return (
    <div className={`mb-10 border p-6 flex flex-wrap items-center gap-6 ${d.badge ? "border-emerald-300 bg-emerald-50" : "border-slate-200 bg-white"}`} data-testid="hummingbird-badge-card">
      <div className={`relative w-20 h-20 shrink-0 flex items-center justify-center rounded-full ${d.badge ? "bg-white ring-4 ring-emerald-400" : "bg-slate-50 ring-2 ring-slate-200"}`}>
        <HummingbirdIcon size={52} flapping={d.badge} />
        {d.badge && <Award size={22} className="absolute -bottom-1 -right-1 text-amber-500 bg-white rounded-full" />}
      </div>
      <div className="flex-1 min-w-[220px]">
        <div className="text-xs font-bold uppercase tracking-overline text-slate-500">Kolibri-Abzeichen</div>
        {d.badge ? (
          <div data-testid="hummingbird-badge-earned">
            <div className="font-heading text-2xl font-light tracking-tighter text-emerald-800 mt-1">Abzeichen verdient!</div>
            <div className="text-sm text-emerald-700 mt-1">{d.on_time} pünktliche Übergaben gesammelt – danke für deine Verlässlichkeit.</div>
          </div>
        ) : (
          <div data-testid="hummingbird-badge-progress">
            <div className="font-heading text-2xl font-light tracking-tighter text-slate-900 mt-1">{d.on_time} / {d.badge_at} bis zum Abzeichen</div>
            <div className="h-1.5 bg-slate-100 mt-3 max-w-sm"><div className="h-full bg-emerald-500 transition-[width] duration-700" style={{ width: `${pct}%` }} /></div>
            <div className="text-xs text-slate-500 mt-2">Jede pünktliche Übergabe an den nächsten Coach oder ins Offboarding bringt dir einen Kolibri.</div>
          </div>
        )}
        <div className="flex flex-wrap gap-0.5 mt-3" data-testid="hummingbird-collection">
          {Array.from({ length: Math.min(d.on_time, 30) }).map((_, i) => <HummingbirdIcon key={i} size={18} flapping={false} />)}
          {d.on_time > 30 && <span className="text-xs text-slate-500 ml-1">+{d.on_time - 30}</span>}
        </div>
      </div>
    </div>
  );
}
